import { Badge, Text } from "@salestrak/ui";

type FilterCountBadgeProps = {
  count: number;
};

export function FilterCountBadge({ count }: FilterCountBadgeProps) {
  if (count === 0) return null;

  return (
    <Badge size="sm">
      <Text>{count}</Text>
    </Badge>
  );
}
